import React, { useState, useRef } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const ModalCreate = ({
  isOpen,
  toggle,
  title,
  token,
}) => {
  const [tipoSolicitud, setTipoSolicitud] = useState("");
  const [, setFormMode] = useState("none");
  const modalRef = useRef(null);

  const handleTipoSolicitudChange = (event) => {
    setTipoSolicitud(event.target.value);
  };


  const handleCreateSubmit = (event) => {
    event.preventDefault();
    axios
      .post("/tiposolicitud", {
        Texto: tipoSolicitud,
      }, {headers: { Authorization: `Bearer ${token}` }})
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Creado!",
          text: "el tipo de solicitud ha sido creada con exito",
          showCloseButton: true,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Ha ocurrido un error al crear el tipo de solicitud.",
          showCloseButton: true,
        });
      });
  };

  return (
    <Modal ref={modalRef} isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label>Tipo de solicitud:</label>
          <input
            className="form-control"
            name="tipoSolicitud"
            type="text"
            value={tipoSolicitud}
            onChange={handleTipoSolicitudChange}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <Button onClick={handleCreateSubmit} color="primary" otype="submit">
          Insertar
        </Button>
        <Button color="danger" onClick={() => setFormMode("none")}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalCreate;
